import RoundedButton from 'components/RoundedButton';
import React, { Component } from 'react';
import Helmet from 'react-helmet';

const CSS = require('./ErrorBoundary.module.scss');

class ErrorBoundary extends Component<
  {},
  { hasError: boolean; error: string | null; errorInfo: string | null }
> {
  state = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error);
    console.error(errorInfo);
    this.setState({
      error: JSON.stringify(error),
      errorInfo: JSON.stringify(errorInfo),
    });
  }

  render() {
    if (this.state.hasError) {
      const onReload = () => window?.location?.reload();
      const onBack = () => window?.history?.back();
      return (
        <>
          <Helmet>
            <meta name="render:status_code" content="500" />
          </Helmet>
          <div className={CSS.Error}>
            <h1 className={CSS.ErrorTitle}>Something went wrong</h1>
            <RoundedButton onClick={onReload}>Retry</RoundedButton>
            <button onClick={onBack} className={CSS.BackLink}>
              Go back
            </button>
            {this.state.error && (
              <code className={CSS.ErrorCode}>
                <pre>{this.state.error}</pre>
                <pre>{this.state.errorInfo}</pre>
              </code>
            )}
          </div>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
